<template>
    <!-- 类型菜单 -->
    <div>
      <div v-if="$route.meta.cate" style="width:200px;color:white;background-color:#057cc3;padding:10px 0px 10px 20px;">
        <i class="el-icon-menu"  style="margin-right:20px;"></i>产品分类
      </div>
      <div v-else @mouseover="isDisplay = true" @mouseleave="isDisplay = false;tmSelected=null;">
        <div style="width:200px;color:white;background-color:#057cc3;padding:10px 0px 10px 20px;">
          <i class="el-icon-menu"  style="margin-right:20px;"></i>产品分类
          
        </div>
        
        <div v-show="isDisplay" class="amoudle_child menu menus" style="width:220px;position:absolute;z-index: 999;" @mouseleave="typeMenushow = false;tmSelected=null;">
          <ul class="type-menu" style="padding:10px 0px;font-size: 14px;">
                  <li class="type-menu-item" 
                  :class="{tmSelected:tmSelected== index}" 
                  v-for="(item,index) in categorylist" :key="index" 
                  @mouseover="selectd(index)" 
                  >
                      <el-link :underline="false">{{item.name}}</el-link>
                  </li>
                  <li class="type-menu-item"><el-link href="#/cata" :underline="false">查看全部分类</el-link> <i class="el-icon-arrow-right"></i></li>
          </ul>
          <div id="type-menu-pop" style="height:463px;" v-show="typeMenushow">
                    <div style="padding:10px 20px 10px 20px;" >
                      <div v-show="tmSelected == index" class="tp-part" v-for="(item,index) in categorylist" :key="index">
                        <div class="tp-pop">
                          <div style="padding:10px;border-bottom:1px solid gray;">
                            {{item.name}}
                          </div>
                          <div class="tp-item" style="overflow: auto;height: 270px;">
                            <el-link @click="t(i.id)" v-for="(i,d) in item.children" :underline="false" :key="d">{{i.name}}</el-link>
                          </div>
                        </div>
                        <div class="recommend">
                          <div style="padding:10px;border-bottom:1px solid gray;">
                          推荐型号
                          </div>
                          <div class="tp-item" style="overflow: auto;height:96px">
                              <el-link :underline="false"></el-link>
                            
                          </div>
                        </div>
                      </div>
                    </div>
          </div>
                
        </div>
      </div>  
    </div>
</template>

<script>

import {EB} from '../EB.js';
import throttle from 'lodash/throttle';
import {mapState} from 'vuex';

export default {
  name: 'Category',
  props:['showSwitch'],
  data(){
    return{
        typeMenushow:false,
        tmSelected:null,   
        typemenu:[],
        isDisplay:false,
    }
  },
  methods:{
      selectd:throttle(function(s){
        this.typeMenushow = true;
        this.tmSelected = s;
      },20),
      t(s){
        this.$router.push('/datail/'+s)       
      },

  },
  mounted(){  
    if(this.$props.showSwitch){
      this.isDisplay = false;
      EB.$on('isdisplay',data => {
        this.isDisplay = data
      })
    }
  },
  computed:{
    ...mapState({
      categorylist:state=>state.home.categorylist,
    })
  }
}
</script>

<style>

.menus{
  border: 1px solid gainsboro;
  margin-left: -1px;
  
}

.menu{
  width:220px;background:white;
}
.amoudle_child{
  margin-right:10px;
}
.type-menu-item{
  padding-left:20px;
  margin: 1px;
  height:25px;
  line-height: 25px;
  display: flex;
  align-items: center;
}
#type-menu-pop{
  position:absolute;top:-1px;
  left: 220px;z-index: 9;
  height: 471px;
  background-color: white;width: 968px;
  border: 1px solid gainsboro;
  
}
.tp-item .el-link{
  margin: 13px;
}
.tmSelected{
    background-color: #057cc3;
}
 
.tmSelected .el-link--inner{
   
    color: white;
}



</style>
